import React from "react";
import { formatLeverage } from "../../utils/format";
import DetailsRow from "../DetailsRow";
import LiquidationPrices from "./LiquidationPrices";
import CurrentPrice from "./CurrentPrice";
import "./index.scss";
import useGenericCall from "../../hooks/useGenericCall";
import { useOnchainAccountLendingPool } from "../../hooks/useOnchain";

interface RiskMetricsProps {
  changeBorrowedA?: number;
  changeBorrowedB?: number;
  changeCollateral?: number;
  hideIfNull?: boolean;
}

/**
 * Generates lending pool aggregate details.
 */
export default function RiskMetrics({changeBorrowedA, changeBorrowedB, changeCollateral, hideIfNull} : RiskMetricsProps) {
  const changes = changeBorrowedA || changeBorrowedB || changeCollateral ? {
    changeBorrowedA: changeBorrowedA ? changeBorrowedA : 0, 
    changeBorrowedB: changeBorrowedB ? changeBorrowedB : 0, 
    changeCollateral: changeCollateral ? changeCollateral : 0,
  } : null;

  const data = useGenericCall(useOnchainAccountLendingPool(), async onchainAccountLendingPool => ({
    currentLeverage: await onchainAccountLendingPool.getLeverage(),
    newLeverage: await onchainAccountLendingPool.getLeverage(changes),
  }), [changeBorrowedA, changeBorrowedB, changeCollateral])

  const leverageExplanation = "Calculated as: Total Collateral / LP Equity";
  const liquidationExplanation = "If the price crosses these boundaries, your account will become liquidatable";

  if (!data) return (null);
  if (hideIfNull && data.currentLeverage === 1) return (null);

  return (<div>
    { changes ? (
      <DetailsRow name="New Leverage" explanation={leverageExplanation}>
        {formatLeverage(data.currentLeverage)}
        <i className="change-arrow" />
        {formatLeverage(data.newLeverage)}
      </DetailsRow>
    ) : (
      <DetailsRow name="Current Leverage" explanation={leverageExplanation}>
        {formatLeverage(data.currentLeverage)}
      </DetailsRow>
    ) }
    { changes ? (
      <DetailsRow name="New Liquidation Prices" explanation={liquidationExplanation}>
        <LiquidationPrices /> 
        <i className="change-arrow" /> 
        <LiquidationPrices changes={changes} />
      </DetailsRow>
    ) : (
      <DetailsRow name="Liquidation Prices" explanation={liquidationExplanation}>
        <LiquidationPrices />
      </DetailsRow>
    ) }
    <CurrentPrice />
  </div>);
}